<section class="title-section">
  <h1 [innerHTML]="'privacy_policy.title' | translate"></h1>
  <p [innerHTML]="'privacy_policy.effective_date' | translate"></p>
  <p [innerHTML]="'privacy_policy.intro' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_1.title' | translate"></h2>

  <h3 [innerHTML]="'privacy_policy.section_1.sub_1.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_1.sub_1.content' | translate"></p>

  <h3 [innerHTML]="'privacy_policy.section_1.sub_2.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_1.sub_2.joint_controllers' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_1.sub_2.centravet_role' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_1.sub_2.vet_role' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_1.sub_2.contact_label' | translate"></p>
  <address [innerHTML]="'privacy_policy.section_1.sub_2.address' | translate"></address>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_2.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_2.intro' | translate"></p>
  <ul>
    <li [innerHTML]="'privacy_policy.section_2.purpose_booking' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_2.purpose_reminders' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_2.purpose_stats' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_2.purpose_legal' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_2.purpose_transfer' | translate"></li>
  </ul>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_3.title' | translate"></h2>

  <h3 [innerHTML]="'privacy_policy.section_3.sub_1.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_3.sub_1.content' | translate"></p>

  <h3 [innerHTML]="'privacy_policy.section_3.sub_2.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_3.sub_2.content' | translate"></p>

  <h3 [innerHTML]="'privacy_policy.section_3.sub_3.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_3.sub_3.no_sale' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_3.sub_3.storage' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_3.sub_3.third_country' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_4.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_4.intro' | translate"></p>
  <table>
    <thead>
    <tr>
      <th [innerHTML]="'privacy_policy.section_4.table.col_category' | translate"></th>
      <th [innerHTML]="'privacy_policy.section_4.table.col_duration' | translate"></th>
      <th [innerHTML]="'privacy_policy.section_4.table.col_basis' | translate"></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td [innerHTML]="'privacy_policy.section_4.table.row_account.category' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_account.duration' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_account.basis' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'privacy_policy.section_4.table.row_history.category' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_history.duration' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_history.basis' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'privacy_policy.section_4.table.row_marketing.category' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_marketing.duration' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_marketing.basis' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'privacy_policy.section_4.table.row_vet.category' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_vet.duration' | translate"></td>
      <td [innerHTML]="'privacy_policy.section_4.table.row_vet.basis' | translate"></td>
    </tr>
    </tbody>
  </table>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_5.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_5.content' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_6.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_6.intro' | translate"></p>
  <ul>
    <li [innerHTML]="'privacy_policy.section_6.right_access' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.right_rectification' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.right_erasure' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.right_restriction' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.right_portability' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.right_opposition' | translate"></li>
  </ul>
  <p [innerHTML]="'privacy_policy.section_6.how_to_exercise_label' | translate"></p>
  <ul>
    <li [innerHTML]="'privacy_policy.section_6.exercise_via_app' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.exercise_via_centravet' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_6.exercise_via_vet' | translate"></li>
  </ul>
  <p [innerHTML]="'privacy_policy.section_6.cnil' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_7.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_7.intro' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_7.centravet_deletion' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_7.vet_deletion' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_8.title' | translate"></h2>
  <p [innerHTML]="'privacy_policy.section_8.consent' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_8.withdrawal' | translate"></p>
</section>

<section>
  <h2 [innerHTML]="'privacy_policy.section_9.title' | translate"></h2>

  <h3 [innerHTML]="'privacy_policy.section_9.sub_1.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_9.sub_1.content' | translate"></p>

  <h3 [innerHTML]="'privacy_policy.section_9.sub_2.title' | translate"></h3>
  <p [innerHTML]="'privacy_policy.section_9.sub_2.non_essential' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_9.sub_2.how_to_manage' | translate"></p>
  <ul>
    <li [innerHTML]="'privacy_policy.section_9.sub_2.manage_via_banner' | translate"></li>
    <li [innerHTML]="'privacy_policy.section_9.sub_2.manage_via_browser' | translate"></li>
  </ul>
  <p [innerHTML]="'privacy_policy.section_9.sub_2.no_third_party' | translate"></p>
  <p [innerHTML]="'privacy_policy.section_9.sub_2.cnil_link' | translate"></p>
</section>
